module.exports = __webpack_public_path__ + "static/media/LogoQuadradoCentralizado.86b35fa6.png";